export const reportsType = {
  title: { default: 'Selecione o tipo:', modal: 'Tipo' },
  items: [
    { label: 'NOTA DE CORRETAGEM', value: 'brokerage-note' },
    // { label: 'MARGEM E GARANTIA', value: 'margin' }, // Descontinuado
    { label: 'INFORME DE RENDIMENTOS ANUAL', value: 'annual-income-report' },
    { label: 'RELATÓRIOS COMPLEMENTARES', value: 'complementary' },
  ],
};

export const reportMarkets = {
  title: { default: 'Selecione o mercado:', modal: 'Selecione o mercado:' },
  items: [
    { label: 'BM&F', value: 'BMF' },
    { label: 'BTC', value: 'BTC' },
    { label: 'AÇÕES', value: 'Bovespa_Acoes' },
    { label: 'OPÇÕES', value: 'Bovespa_Opcoes' },
    { label: 'RENDA FIXA', value: 'FixedIncome' },
  ],
};

export const reportsPeriod = {
  title: { default: 'Período', modal: 'Período' },
  items: [
    { label: 'Diário', value: 'Daily' },
    { label: 'Mensal', value: 'Month' },
  ],
};

export const reportsYears = {
  title: { default: 'Período', modal: 'Selecione o ano:' },
};

export const reportsPeriodYears = {
  title: { default: 'Período:', modal: 'Período:' },
};

export const reportsComplementaryTitles = {
  title: { default: 'Titulo:', modal: 'Titulo:' },
};

export const reportsMonths = {
  title: { default: 'Mês', modal: 'Selecione o mês:' },
  items: [
    { label: 'Jan', value: 'Jan', filterValue: 1 },
    { label: 'Fev', value: 'Fev', filterValue: 2 },
    { label: 'Mar', value: 'Mar', filterValue: 3 },
    { label: 'Abr', value: 'Abr', filterValue: 4 },
    { label: 'Mai', value: 'Mai', filterValue: 5 },
    { label: 'Jun', value: 'Jun', filterValue: 6 },
    { label: 'Jul', value: 'Jul', filterValue: 7 },
    { label: 'Ago', value: 'Ago', filterValue: 8 },
    { label: 'Set', value: 'Set', filterValue: 9 },
    { label: 'Out', value: 'Out', filterValue: 10 },
    { label: 'Nov', value: 'Nov', filterValue: 11 },
    { label: 'Dez', value: 'Dez', filterValue: 12 },
  ],
};

const today = new Date();
const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
const curretYear = today.getFullYear().toString();

export const initialReportTypeOption = reportsType.items[0].value;
export const initialReportMarketOption = reportMarkets.items[0].value;
export const initialReportPeriodOption = reportsPeriod.items[0].value;
export const initialReportMonthOption: string[] = [];
export const initialReportPeriodDates = { startDate: yesterday, endDate: today };

export const currentReportYearOption = curretYear;
